/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_America_Denver2Inputs */

const he_timezone_america_denver2 = /** @type {(inputs: Timezone_America_Denver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mountain Time (US)`)
};

const en_timezone_america_denver2 = /** @type {(inputs: Timezone_America_Denver2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mountain Time (US)`)
};

/**
* | output |
* | --- |
* | "Mountain Time (US)" |
*
* @param {Timezone_America_Denver2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_america_denver2 = /** @type {((inputs?: Timezone_America_Denver2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_America_Denver2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_america_denver2(inputs)
	return en_timezone_america_denver2(inputs)
});
export { timezone_america_denver2 as "timezone_America_Denver" }